'use client';
import React, { useEffect, useState } from 'react';

import IconScrollButton from '@/assets/icons/iconScrollButton.svg';
import { ScrollButton } from '@/shared/components/scrollButton';
import { classNames } from '@/shared/lib/classNames/classNames';

export const ScrollButtonToTop = () => {
  const [isVisibleScroll, setIsVisibleScroll] = useState(false);

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    }

    const scroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      scrollY > 1200 ? setIsVisibleScroll(true) : setIsVisibleScroll(false);
    };
    window.addEventListener('scroll', scroll);
    return () => window.removeEventListener('scroll', scroll);
  }, []);

  return (
    <ScrollButton
      target="body_top"
      className={classNames(
        'fixed bottom-[30px] left-[20px] z-[9] block opacity-[1] max-md:hidden',
        {
          visible: isVisibleScroll,
          hidden: !isVisibleScroll,
        },
      )}
    >
      <IconScrollButton />
    </ScrollButton>
  );
};
